module.exports = __webpack_public_path__ + "static/heroVid-c34131887998fd097c38303535f3c705.mp4";